import { diffDaysFromToday, pickDate } from "./dateUtils";

const buildPersonName = (persona) =>
    [persona?.nombre, persona?.apellidos].filter(Boolean).join(" ") || persona?.nombre || "—";

export const buildAlertsForPerson = (persona, horizonDays) => {
    const out = [];
    const personId = persona?.id;
    const personName = buildPersonName(persona);

    // Documento
    const fechaDoc = pickDate(persona);
    if (fechaDoc) {
        const daysLeft = diffDaysFromToday(fechaDoc);
        const status = daysLeft < 0 ? "expired" : daysLeft <= horizonDays ? "soon" : "ok";
        if (status !== "ok") {
            out.push({
                id: `P-${personId}::DOC`,
                personId,
                personName,
                tipo: "personaDoc",
                label: "Documento",
                meta: `${persona?.tipoDocumentoDescripcion || persona?.tipoDocumento || "Doc."}${persona?.numeroDocumento ? ` • Nº ${persona.numeroDocumento}` : ""
                    }`,
                fecha: fechaDoc,
                daysLeft,
                status,
            });
        }
    } else {
        out.push({
            id: `P-${personId}::DOC-MISSING`,
            personId,
            personName,
            tipo: "personaDoc",
            label: "Documento",
            meta: `${persona?.tipoDocumentoDescripcion || persona?.tipoDocumento || "Doc."}${persona?.numeroDocumento ? ` • Nº ${persona.numeroDocumento}` : ""
                }`,
            fecha: null,
            daysLeft: null,
            status: "missing",
        });
    }

    // Licencias armas
    (persona?.licenciasArmas || []).forEach((lic, idx) => {
        if (lic?.fechaIndefinida === true) return;

        const fecha = pickDate(lic);
        if (fecha) {
            const daysLeft = diffDaysFromToday(fecha);
            const status = daysLeft < 0 ? "expired" : daysLeft <= horizonDays ? "soon" : "ok";
            if (status !== "ok") {
                out.push({
                    id: `P-${personId}::LA-${lic.id ?? idx}`,
                    personId,
                    personName,
                    tipo: "licArmas",
                    label: "Licencia de armas",
                    meta: `${lic?.tipoDescripcion || lic?.tipo || ""}${lic?.numero ? ` • Nº ${lic.numero}` : ""}`.trim(),
                    fecha,
                    daysLeft,
                    status,
                });
            }
        } else {
            out.push({
                id: `P-${personId}::LA-${lic.id ?? idx}-MISSING`,
                personId,
                personName,
                tipo: "licArmas",
                label: "Licencia de armas",
                meta: `${lic?.tipoDescripcion || lic?.tipo || ""}${lic?.numero ? ` • Nº ${lic.numero}` : ""}`.trim(),
                fecha: null,
                daysLeft: null,
                status: "missing",
            });
        }
    });

    // Licencias caza
    (persona?.licenciasCaza || []).forEach((lic, idx) => {
        const fecha = pickDate(lic);
        if (fecha) {
            const daysLeft = diffDaysFromToday(fecha);
            const status = daysLeft < 0 ? "expired" : daysLeft <= horizonDays ? "soon" : "ok";
            if (status !== "ok") {
                out.push({
                    id: `P-${personId}::LC-${lic.id ?? idx}`,
                    personId,
                    personName,
                    tipo: "licCaza",
                    label: "Licencia de caza",
                    meta: `${lic?.numero || ""}${lic?.ambito ? ` • ${lic.ambito}` : ""}`.trim(),
                    fecha,
                    daysLeft,
                    status,
                });
            }
        } else {
            out.push({
                id: `P-${personId}::LC-${lic.id ?? idx}-MISSING`,
                personId,
                personName,
                tipo: "licCaza",
                label: "Licencia de caza",
                meta: `${lic?.numero || ""}${lic?.ambito ? ` • ${lic.ambito}` : ""}`.trim(),
                fecha: null,
                daysLeft: null,
                status: "missing",
            });
        }
    });

    // Seguros
    (persona?.seguros || []).forEach((seg, idx) => {
        const fecha = pickDate(seg);
        if (fecha) {
            const daysLeft = diffDaysFromToday(fecha);
            const status = daysLeft < 0 ? "expired" : daysLeft <= horizonDays ? "soon" : "ok";
            if (status !== "ok") {
                out.push({
                    id: `P-${personId}::SE-${seg.id ?? idx}`,
                    personId,
                    personName,
                    tipo: "seguro",
                    label: "Seguro",
                    meta: `${seg?.compania || seg?.aseguradora || seg?.compañia || ""}${seg?.numeroPoliza ? ` • Póliza ${seg.numeroPoliza}` : ""
                        }`.trim(),
                    fecha,
                    daysLeft,
                    status,
                });
            }
        } else {
            out.push({
                id: `P-${personId}::SE-${seg.id ?? idx}-MISSING`,
                personId,
                personName,
                tipo: "seguro",
                label: "Seguro",
                meta: `${seg?.compania || seg?.aseguradora || seg?.compañia || ""}${seg?.numeroPoliza ? ` • Póliza ${seg.numeroPoliza}` : ""
                    }`.trim(),
                fecha: null,
                daysLeft: null,
                status: "missing",
            });
        }
    });

    return out;
};
